{
  "id": "campaign-051",
  "name": "Lucky Acre II",
  "seed": "campaign:51",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........RRRR",
    "..q.....RRRR",
    "........____",
    "............",
    "...x..e...q.",
    "......e.....",
    "......e.....",
    "......e.....",
    "......e.....",
    "..ffffffffff",
    "............",
    ".cc......cc.",
    ".cc......cc.",
    ".u.u....u.u.",
    "....y..y....",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 10,
      "y": 6
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 6
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 51,
  "biome": "farm",
  "par": {
    "reel": 5970,
    "push": 5278,
    "selfPropelled": 5112,
    "tractor": 5000,
    "zeroTurn": 3417,
    "fairway": 2244
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 19,
      "selfPropelled": 23,
      "tractor": 5,
      "zeroTurn": 5,
      "fairway": 19
    }
  }
}
